type GetPolyfills = () => Promise<any>[];
export const getPolyfills: GetPolyfills = () => {
  const polyfills: Promise<any>[] = [];

  if (!('performance' in window) || !('now' in window.performance)) {
    polyfills.push(import(/* webpackChunkName: "2-polyfill-usertiming" */ 'usertiming'));
  }

  const match = navigator.userAgent.match(/Edge\/(\d+)/);
  const edgeVersion = match && match[1] && parseInt(match[1], 10);

  if (navigator && edgeVersion && edgeVersion < 16) {
    // https://www.yammer.com/microsoft.com/#/Threads/show?threadId=1022874944
    delete (window as any).fetch;
  }

  if (!('fetch' in window)) {
    polyfills.push(import(/* webpackChunkName: "2-polyfill-fetch" */ 'whatwg-fetch'));
  }

  if (!('requestIdleCallback' in window) || !('cancelIdleCallback' in window)) {
    polyfills.push(
      import(/* webpackChunkName: "2-polyfill-idle" */ 'requestidlecallback').then((module) => {
        const { request: requestIdleCallback, cancel: cancelIdleCallback } = module.default;
        window.requestIdleCallback = requestIdleCallback;
        window.cancelIdleCallback = cancelIdleCallback;

        return module;
      })
    );
  }

  if (
    !('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in (window as any).IntersectionObserverEntry.prototype) ||
    !('isIntersecting' in (window as any).IntersectionObserverEntry.prototype)
  ) {
    polyfills.push(import(/* webpackChunkName: "2-polyfill-intersectionobserver" */ 'intersection-observer'));
  }

  if (!('ResizeObserver' in window)) {
    polyfills.push(
      import(/* webpackChunkName: "2-polyfill-resizeobserver" */ 'resize-observer-polyfill').then((module) => {
        (window as any).ResizeObserver = module.default;

        return module;
      })
    );
  }

  return polyfills;
};
